<template>
  <span>{{ str }}</span>
</template>
<script>
import moment, { Moment } from "moment";

export default {
  props: { date: Moment },
  computed: {
    str() {
      const t = moment().valueOf() - this.date.valueOf();
      if (t < 1000 * 60) {
        return "刚刚";
      } else if (t < 1000 * 60 * 60) {
        return this.date.startOf("minute").fromNow().replace(" ", "");
      } else if (t < 1000 * 60 * 60 * 24) {
        return this.date.startOf("hour").fromNow().replace(" ", "");
      } else if (t < 1000 * 60 * 60 * 24 * 7) {
        const date =  moment(this.date.format('YYYY-MM-DD'))
        const current = moment(moment().format('YYYY-MM-DD'))
        return date.startOf("day").from(current).replace(" ", "");
      } else {
        return this.date.format("YYYY/MM/DD");
      }
    },
  },
};
</script>

<style scoped></style>
